import { MetricsSkeleton } from "components/PortalLoading";
import DashboardWelcome from "components/PortalDashboard";
import DashboardReports from "components/PortalDashboard/DashboardReports";
import { useUrlQuery } from "hooks/useUrlQuery";
import PublisherAggregateBooks from "admin/PublisherDashboard2/PublisherAggregateBooks";
import Admin2 from "layouts/Admin2";
import PublisherRevenueReport from "admin/PublisherDashboard2/PublisherRevenueReport";
import useProfile from "api/UserResource/useProfile";
import PublisherBookPerformance from "./PublisherBookPerformance";
import BookMetricsExportPanel from "admin/AdminDashboard2/Reports/BookMetricsExportPanel";
import useAuthStore from "store/authStore";
import { Role } from "utils/server-constants/roles";

const Profile = ({ firstName, lastName, email, mobileNumber }) => (
    <dl className="portal-profile-summary" aria-label="Publisher details">
        {[["First name", firstName], ["Last name", lastName], ["Email address", email], ["Mobile number", mobileNumber]].map(([label, value]) => <div key={label}><dt>{label}</dt><dd>{value || "—"}</dd></div>)}
    </dl>
);

const PublisherDashboard2 = () => {
	const userId = useUrlQuery()?.get("userId") || null;

	const { hasRoles } = useAuthStore();

	const { data: profile, isLoading: profileLoading } = useProfile(userId);

	return (
		<Admin2>
			<div className="portal-dashboard">
                <DashboardWelcome variant="publisher" />
                <PublisherAggregateBooks userId={userId} />
                <details className="portal-publisher-details"><summary>Publisher details</summary>
				{profileLoading ? <MetricsSkeleton label="Loading publisher details…" labels={["First name", "Last name", "Email address", "Mobile number"]} /> : <Profile
					firstName={profile?.data?.first_name}
					lastName={profile?.data?.last_name}
					email={profile?.data?.email}
					mobileNumber={profile?.data?.mobile_number}
				/>}
                </details>
                <DashboardReports>
                    <PublisherRevenueReport userId={userId} />
                    <PublisherBookPerformance userId={userId} />
                </DashboardReports>

				{hasRoles([Role.SeniorPublisher, Role.Publisher]) && <BookMetricsExportPanel />}

			</div>
		</Admin2>
	);
};

export default PublisherDashboard2;
